import { Injector, Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter',
  standalone: false,
})
export class FilterPipe implements PipeTransform {
  public constructor(private readonly injector: Injector) {}

  /**
   * Filters values that get passed in
   *
   * @param value array of values to be filtered
   * @param callback function, to define what should be filtered
   * @result filtered values
   */
  transform(value: Array<any>, callback: any): any {
    return value.filter(callback);
  }
}
